import SubmitButton from 'v2/modules/withRunForm/components/SubmitButton/index';
import RunFormHeader from 'v2/modules/withRunForm/components/RunFormHeader/index';
import withRunForm from 'v2/modules/withRunForm/index';
import { useForm, FormProvider } from 'react-hook-form';
import QuantBuilder from './QuantBuilder';
import RunCreditDetails from './components/RunCreditDetails/index';
import SiteTourResetButton from 'v3/pages/SiteTour/SiteTourResetButton';
import { DemoPages } from 'v3/pages/SiteTour/type';

const Main = () => {
  const methods = useForm();

  return (
    <FormProvider {...methods}>
      <div className="v2-form-container container">
        <SiteTourResetButton pageName={DemoPages.ADVANCEDBUILDER} />
        <RunFormHeader />
        <QuantBuilder />
        <RunCreditDetails />
        <div className="submit-button-wrapper">
          <SubmitButton />
        </div>
      </div>
    </FormProvider>
  );
};

Main.propTypes = {};

export default withRunForm(Main);
